import { css, SerializedStyles } from '@emotion/react';
import { getBaseFontSize } from '@frontend/theme-original';
import { theme } from '@frontend/theme';
import { styles } from '../../../../styles';
import { DirectionProps } from '../../hooks/types';

type DropdownProps = { active?: boolean } & DirectionProps;

type InputStyleProps = { isPlaceholder: boolean; disabled: boolean };

const BASE = getBaseFontSize();

export const activeDropdownStyle: (placement: string) => SerializedStyles = (placement = 'bottom') =>
  placement === 'bottom'
    ? css`
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
      `
    : css`
        border-top-right-radius: 0;
        border-top-left-radius: 0;
      `;

export const placeholderStyle = css`
  color: ${theme.colors.neutral50};
`;

export const inputStyle = ({ isPlaceholder, disabled }: InputStyleProps) => [
  css`
    font-family: ${theme.font.family};
    font-size: ${theme.fontSize(16)};
    line-height: 1.375;
    padding-right: ${theme.spacing(4)};
    text-align: left;
    ${isPlaceholder && `color: ${theme.colors.neutral50}`}
    ${styles.truncate}
  > input[type='text'] {
      margin-right: 0;
      padding-right: ${theme.spacing(3)};
      ::placeholder {
        color: ${theme.colors.neutral50};
      }
    }
  `,
  disabled &&
    css`
      color: ${theme.colors.status.disabled};
    `,
];
const upperBoxShadow = '1px -5px 14px 2px rgb(49 53 61 / 24%)';

export const dropdownMenuStyle = ({ direction, active }: DropdownProps) => css`
  width: 100%;
  max-height: ${208 / BASE}rem;
  background: white;
  box-shadow: ${direction === 'up' ? upperBoxShadow : theme.shadows.heavy};
  border-radius: ${direction === 'up' ? `${theme.borderRadius.small} 0` : `0 ${theme.borderRadius.small}`};
  bottom: -1px;
  left: 0;
  overflow: auto;
  transform: ${direction === 'up' ? `translateY(-52px)` : `translateY(100%)`};
  z-index: ${active ? theme.zIndex.high : theme.zIndex.base};
  :focus {
    outline: none;
  }
  ${!active && `pointer-events: none;`}
`;

export const DropdownInputStyles = {
  inputStyle: (displayValue: InputStyleProps) => inputStyle(displayValue ?? {}),
  dropdownMenuStyle: (dropdownProps: DropdownProps) => dropdownMenuStyle(dropdownProps),
  placeholderStyle: placeholderStyle,
};
